export interface DynamicCx {
  (...className): any
  dynamic: Function
  remove: Function
}

export const insertCss = (...styles) => {
  const removeCss = styles.map(x => x._insertCss())
  return () => {
    removeCss.forEach(f => f())
  }
}
